import { Component, ComponentInterface, h, Host, JSX, Prop } from '@stencil/core';
import { MercedesBenzClaim, MercedesBenzStar } from './logo';

/* eslint-disable */
/**
 * @slot - Contents placed within the main area
 */
@Component({
  tag: 'wb-header-bar',
  styleUrl: 'header-bar.scss',
  shadow: true,
})
export class HeaderBarComponent implements ComponentInterface {
  /** href passed to the anchor tag around the star */
  @Prop()
  public starHref?: string;

  /** can be used in combination with `starHref` property */
  @Prop()
  public rel?: string;

  /** can be used in combination with `starHref` property */
  @Prop()
  public target?: string;

  /** star label used for screen-readers */
  @Prop()
  public starLabel?: string;

  public render(): JSX.Element {
    return (
      <Host class="wb-header-bar">
        <div class="inner">
          <div class="logo-container">
            <a class="logo" aria-label={this.starLabel} href={this.starHref} rel={this.rel} target={this.target}>
              <MercedesBenzClaim />
              <MercedesBenzStar />
            </a>
          </div>
          <div class="meta">
            <div class="desktop-meta">
              <slot name="desktop-meta"></slot>
            </div>

            <div class="tablet-meta">
              <div class="row">
                <slot name="tablet-meta-start"></slot>
              </div>
              <div class="row">
                <slot name="tablet-meta-end"></slot>
              </div>
            </div>

            <div class="mobile-meta">
              <div class="row">
                <slot name="mobile-meta-start"></slot>
              </div>
              <div class="row">
                <slot name="mobile-meta-end"></slot>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
